// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // <-- viktigt för PWA

// --- Global fel- och promise-lyssnare för att undvika "vit sida" ---
function logError(prefix, err) {
  // eslint-disable-next-line no-console
  console.error(prefix, err && (err.reason || err.error || err.message || err));
}

// Rensa SW + cache och ladda om om en chunk/bundle fallerar
async function recoverFromChunkLoad() {
  try {
    // Unregister alla service workers
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.allSettled(regs.map(r => r.unregister()));
    }
    // Rensa alla Cache Storage
    if (window.caches && caches.keys) {
      const keys = await caches.keys();
      await Promise.allSettled(keys.map(k => caches.delete(k)));
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[RECOVERY] kunde inte städa allt:', e);
  } finally {
    // Ladda om sidan
    window.location.reload(true);
  }
}

// Heuristik: om felet ser ut som en trasig chunk eller nätverksfel => recovery
function shouldRecover(err) {
  const msg = String(
    (err && (err.reason?.message || err.reason)) ||
    (err && (err.message || err)) ||
    ''
  ).toLowerCase();

  return (
    msg.includes('loading chunk') ||
    msg.includes('chunkloaderror') ||
    msg.includes('failed to fetch') ||
    msg.includes('script error') ||
    msg.includes('css chunk') ||
    msg.includes('net::err') ||
    msg.includes('networkerror') ||
    msg.includes('unexpected token <') // ibland när HTML cachas istället för JS
  );
}

// Fånga tysta promise-fel
window.addEventListener('unhandledrejection', (e) => {
  logError('[UNHANDLED REJECTION]', e);
  if (shouldRecover(e)) recoverFromChunkLoad();
});

// Fånga vanliga fel
window.addEventListener('error', (e) => {
  logError('[UNCAUGHT ERROR]', e);
  if (shouldRecover(e)) recoverFromChunkLoad();
});

// --- Render ---
const root = ReactDOM.createRoot(document.getElementById('root'));
try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (e) {
  logError('[RENDER ERROR]', e);
  // Som sista utväg: försök återhämta om själva rendringen dog pga trasig bundle
  if (shouldRecover(e)) recoverFromChunkLoad();
}

// --- Starta service worker (PWA) ---
// Lägg gärna till callbacks för synligare uppdateringar
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // eslint-disable-next-line no-console
    console.log('[SW] Ny uppdatering tillgänglig');
    // Force refresh av sidan när ny SW är redo (minskar risk för “vit sida”)
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      registration.waiting.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  },
  onSuccess: () => {
    // eslint-disable-next-line no-console
    console.log('[SW] Registrerad');
  }
});

// Prestandamätning (valfritt)
reportWebVitals();
